import { useTranslation } from 'react-i18next'

import BasicLayout from '@/components/common/BasicLayout/BasicLayout'

import SectionForm from '../components/SectionForm'
import { useSectionForm, type SectionFormValues } from '../hooks/useSectionForm'

const SectionsAddView = () => {
  const { t } = useTranslation('sections')

  const form = useSectionForm()

  const handleSubmit = (formValues: SectionFormValues) => {
    // TODO: Implement it https://panowie.atlassian.net/browse/RG-303
    console.log(formValues)
  }

  return (
    <BasicLayout
      breadcrumbs={[
        {
          title: t('header.sections'),
          to: '/sections/list'
        },
        {
          title: t('header.add-new-section'),
          to: '/sections/add'
        }
      ]}
      header={t('header.add-new-section')}
      moduleName={t('header.administration', { ns: 'common' })}
    >
      <SectionForm form={form} onSubmit={handleSubmit} />
    </BasicLayout>
  )
}

export default SectionsAddView
